import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { setDashboardData } from "../redux/reducers/dashboardSlice";

const Disclaimer = () => {
    const dispatch = useDispatch();
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        dispatch(setDashboardData({
            showDisclaimer: false
        }))
        setIsVisible(false);
    };

    return (
        <>
            {isVisible && (
                <div id="animate">
                    <h3 className="disclaimerHead">Disclaimer</h3>
                    <div className="disclaimerdiv">
                        <ul className='disclaimer-ul'>
                            <li>This statement reflects transactions up to the date/time of issuance. Recent transactions may not yet be authorized and could be subject to charges, affecting your account value.</li>
                            <li>The information provided in this application is for informational purposes only and should not be relied upon for trading or investment decisions.</li>
                            <li>Prices and valuations displayed are not live and may be subject to market movements. Please refer to official market sources or contact your Relationship Manager for real-time data.</li>

                            {/* <li>The stock prices displayed in this document are for informational purposes only and are not live. They may not reflect current market conditions and should not be relied upon for trading or investment decisions.</li> */}
                        </ul>
                    </div>
                    <div className="close-disclaimer" onClick={handleClose}>
                        x
                    </div>
                </div>
            )}
        </>
    );
};

export default Disclaimer;
